'use client'

import {
  addOrRemoveCompanyLocation,
  addOrRemoveCompanyLocationContinents,
  setCompanyLocation,
} from '@/app/globalRedux/filter/commonFilter'
import {
  addAllCultivationTypeCompany,
  addOrRemoveCompanySelectedActivity,
  companyFvStaticBuyer,
  companyFvStaticSupplier,
  removeAllCultivationTypeCompany,
  setCultivationTypeCompany,
  setSelectAllCompanyBuyers,
  setSelectAllCompanySuppliers,
} from '@/app/globalRedux/filter/companyFilter'
import {
  addAllCultivationType,
  addOrRemoveFruitVegetableActivity,
  removeAllCultivationType,
  setCultivationType,
  setSelectAllProductBuyers,
  setSelectAllProductSuppliers,
} from '@/app/globalRedux/filter/productFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CompanyLocationFilter from '../CommonFilters/CompanyLocationFilter'
import ProductsFilter from '../CommonFilters/ProductsFilter'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'

const CompanyFilterSections = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const goToPage = usePageNumberUpdator()

  const { fvListedSupplier, fvListedBuyer } = useSelector(
    (state: RootState) => state.companyFilterList
  )
  const companyFilter = useSelector((state: RootState) => state.companyFilter)
  const commonFilter = useSelector((state: RootState) => state.commonFilter)
  const [allbuyerSelected, setAllbuyerSelected] = useState<boolean>(false)
  const [allsupplierSelected, setAllsupplierSelected] = useState<boolean>(false)
  const [companyLocation, setCompanyLocationText] = useState<string>('')

  useEffect(() => {
    const activitySet = new Set(companyFilter.fvSelectedActivity)
    setAllbuyerSelected(
      companyFvStaticBuyer.every((buyer) => activitySet.has(buyer))
    )
    setAllsupplierSelected(
      companyFvStaticSupplier.every((supplier) => activitySet.has(supplier))
    )
  }, [companyFilter?.fvSelectedActivity])

  useEffect(() => {
    setCompanyLocationText('')
  }, [companyFilter?.clearFilter])
  return (
    <div>
      {/* {Activity Filter} */}
      {(companyFilter.sector === 'Fruit & Vegetable' ||
        companyFilter.sector === 'Retail Chains') && (
        <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
          <div>
            <Accordion type="single" collapsible defaultValue="item-2">
              <AccordionItem value="item-2">
                <AccordionTrigger className="text-[18px] font-semibold text-[#222]">
                  {t('Activities')}
                </AccordionTrigger>
                <AccordionContent className="!p-0 ">
                  {/* {Suppliers} */}
                  <Accordion
                    type="single"
                    collapsible
                    className="!p-0"
                    defaultValue="supplier"
                  >
                    <AccordionItem value="supplier" className="pb-[10px]">
                      <AccordionTrigger className="text-[18px] font-semibold text-[#222] bg-[#eaeaea] mb-[10px]">
                        <span
                          className=" flex flex-row   items-center w-[100%] gap-[10px]"
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        >
                          <Checkbox
                            className=" bg-[white]"
                            checked={allsupplierSelected}
                            onClick={() => {
                              dispatch(setSelectAllCompanySuppliers())
                              dispatch(setSelectAllProductSuppliers())
                              goToPage({ newPageNo: 1 })
                            }}
                          />
                          <p>{t('Suppliers')}</p>
                        </span>
                      </AccordionTrigger>
                      <AccordionContent className="px-[0px]">
                        <div className="flex flex-col  gap-[8px]">
                          {fvListedSupplier?.map(
                            (supplier: {
                              value: string
                              activityCount: number
                            }) => (
                              <div
                                className=" flex flex-row items-center gap-2  w-fit "
                                key={supplier?.value}
                              >
                                <Checkbox
                                  checked={companyFilter.fvSelectedActivity.includes(
                                    supplier?.value
                                  )}
                                  id={supplier?.value}
                                  className="border-2 border-input"
                                  onClick={() => {
                                    dispatch(
                                      addOrRemoveCompanySelectedActivity(
                                        supplier?.value
                                      )
                                    )
                                    dispatch(
                                      addOrRemoveFruitVegetableActivity(
                                        supplier?.value
                                      )
                                    )
                                    goToPage({ newPageNo: 1 })
                                  }}
                                />
                                <Label
                                  htmlFor={supplier?.value}
                                  className="!cursor-pointer gap-[1px] text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f] flex flex-row"
                                >
                                  {t(supplier?.value)}
                                  <span className=" ml-1 gap-[1px] flex flex-row">
                                    ({supplier?.activityCount})
                                  </span>
                                </Label>
                              </div>
                            )
                          )}
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>

                  {/* {Buyers} */}
                  <Accordion
                    type="single"
                    collapsible
                    className="!p-0 "
                    defaultValue="buyer"
                  >
                    <AccordionItem value="buyer">
                      <AccordionTrigger className="text-[18px] font-semibold text-[#222] bg-[#eaeaea] mb-[10px]">
                        <span
                          className=" flex flex-row   items-center w-[100%] gap-[10px]"
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        >
                          <Checkbox
                            className=" bg-[white]"
                            checked={allbuyerSelected}
                            onClick={() => {
                              dispatch(setSelectAllProductBuyers())
                              dispatch(setSelectAllCompanyBuyers())
                              goToPage({ newPageNo: 1 })
                            }}
                          />
                          <p>{t('Buyers')}</p>
                        </span>
                      </AccordionTrigger>
                      <AccordionContent>
                        <div className="flex flex-col  gap-[8px]">
                          {fvListedBuyer?.map(
                            (buyer: {
                              value: string
                              activityCount: number
                            }) => (
                              <div
                                className="  flex flex-row items-center gap-2  w-fit "
                                key={buyer?.value}
                              >
                                <Checkbox
                                  checked={companyFilter.fvSelectedActivity.includes(
                                    buyer?.value
                                  )}
                                  id={buyer?.value}
                                  onClick={() => {
                                    dispatch(
                                      addOrRemoveCompanySelectedActivity(
                                        buyer?.value
                                      )
                                    )
                                    dispatch(
                                      addOrRemoveFruitVegetableActivity(
                                        buyer?.value
                                      )
                                    )
                                    goToPage({ newPageNo: 1 })
                                  }}
                                  className="border-2 border-input"
                                />
                                <Label
                                  htmlFor={buyer?.value}
                                  className=" cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f] flex flex-row"
                                >
                                  {t(buyer?.value)}
                                  <span className=" ml-1 gap-[1px] flex flex-row">
                                    ({`${buyer?.activityCount}`})
                                  </span>
                                </Label>
                              </div>
                            )
                          )}
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      )}
      {/* Cultivation Type */}
      {companyFilter.sector === 'Fruit & Vegetable' && (
        <>
          <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
            <div>
              <Accordion
                type="single"
                collapsible
                defaultValue="CultivationType"
              >
                <AccordionItem value="CultivationType">
                  <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
                    {t('Cultivation Type')}
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="flex flex-col  gap-[8px]  max-h-[200px] overflow-y-scroll ">
                      <div className=" flex flex-row items-center gap-2 ">
                        <Checkbox
                          checked={
                            companyFilter.cultivationType
                              ?.join()
                              ?.includes('Conventional') &&
                            companyFilter.cultivationType
                              ?.join()
                              ?.includes('Organic')
                          }
                          id={'All'}
                          className=" cursor-pointer border-2 border-input"
                          onClick={() => {
                            if (companyFilter.cultivationType.length !== 2) {
                              dispatch(addAllCultivationType())
                              dispatch(addAllCultivationTypeCompany())
                            } else {
                              dispatch(removeAllCultivationType())
                              dispatch(removeAllCultivationTypeCompany())
                            }
                            goToPage({ newPageNo: 1 })
                          }}
                        />
                        <Label
                          htmlFor="All"
                          className=" cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                        >
                          {t('All')}
                        </Label>
                      </div>
                      <div className=" flex flex-row items-center gap-2 ">
                        <Checkbox
                          checked={companyFilter.cultivationType
                            ?.join()
                            ?.includes('Conventional')}
                          id="Conventional"
                          className="border-2 border-input"
                          onClick={() => {
                            dispatch(setCultivationType('Conventional'))
                            dispatch(setCultivationTypeCompany('Conventional'))
                            goToPage({ newPageNo: 1 })
                          }}
                        />
                        <Label
                          htmlFor="Conventional"
                          className="cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                        >
                          {t('Conventional')}
                        </Label>
                      </div>
                      <div className=" flex flex-row items-center gap-2 ">
                        <Checkbox
                          checked={companyFilter.cultivationType
                            ?.join()
                            ?.includes('Organic')}
                          id="Organic"
                          className="border-2 border-input"
                          onClick={() => {
                            dispatch(setCultivationType('Organic'))
                            dispatch(setCultivationTypeCompany('Organic'))
                            goToPage({ newPageNo: 1 })
                          }}
                        />
                        <Label
                          htmlFor="Organic"
                          className=" cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                        >
                          {t('Organic')}
                        </Label>
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </>
      )}
      {/* Product Filter */}
      {companyFilter.sector !== 'Retail Chains' && <ProductsFilter />}
      {/* Company Location */}
      <CompanyLocationFilter
        searchTitle={'Company Location'}
        locationText={companyLocation}
        setLocationText={setCompanyLocationText}
        continentSelectedList={commonFilter?.companyLocationContinents}
        countrySelectedList={commonFilter?.companyLocation}
        setWholeLocation={setCompanyLocation}
        addOrRemoveSelectedCountryList={addOrRemoveCompanyLocation}
        addOrRemoveSelectedContinentList={addOrRemoveCompanyLocationContinents}
      />
    </div>
  )
}

export default CompanyFilterSections
